<template>
  <v-col>
    <validation-provider v-slot="{ errors }" :rules="rules" :name="name">
      <v-autocomplete
        v-model="internalValue"
        label="Região"
        multiple
        :items="regioes"
        item-text="sigla"
        item-value="public_id"
        @change="$emit('change', $event)"
        :error-messages="errors"
      ></v-autocomplete>
    </validation-provider>
  </v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'RelatorioPerformanceRegiaoFiltroModalItemInputRegiao',
  props: {
    name: {
      type: String,
      required: true,
    },
    fornecedor: {
      type: [Object, String],
      required: true,
    },
    rules: {
      type: [Object, String],
    },
    value: {
      required: true,
    },
  },
  data() {
    return {
      regioes: [],
    }
  },
  computed: {
    ...mapState('auth', ['empresaAtual']),
    internalValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  methods: {
    ...mapActions('patio', ['getRegioes', 'getRegioesColaborator']),

    async atualizaRegioes(fornecedor) {
      if (this.empresaAtual.representantes.length > 0)
        return await this.getRegioesColaborator()

      if (!fornecedor) return []

      const id = fornecedor.fornecedor_id

      return await this.getRegioes({ public_id: id })
    },
  },
  async created() {
    if (this.fornecedor) {
      this.regioes = await this.atualizaRegioes(this.fornecedor)
    }
  },
  watch: {
    async fornecedor(novoFornecedor, antigoFornecedor) {
      if (!novoFornecedor) {
        this.regioes = []
        this.internalValue = []
        return
      }

      this.regioes = await this.atualizaRegioes(novoFornecedor)

      if (antigoFornecedor) {
        this.internalValue = []
      }
    },
  },
}
</script>
